export default __webpack_public_path__ + "d957456a23932b6e1cca310040ba51a8.svg";